import BaseError from './base-error'

export default class NotInitializedError extends BaseError {
  public constructor(className: string) {
    super(`${className} must be initialized first.`, 'not_initialized_error')
  }
}
